var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFlag1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--fxemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF473E",
    d: "M1 312.52v101.445c0 7.251 4.94 13.588 11.981 15.318c159.163 39.106 318.326-43.539 477.489-8.034c9.83 2.193 19.149-5.331 19.149-15.403V312.52c-169.54-48.324-339.079 48.324-508.619 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B67B2",
    d: "M1 198.935v113.586c169.54 48.324 339.079-48.324 508.619 0V198.935c-169.54-48.324-339.079 48.324-508.619 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M1 101.194v97.741c169.54 48.324 339.079-48.324 508.619 0V93.075c0-7.251-4.94-13.588-11.981-15.318c-159.163-39.106-318.326 43.539-477.489 8.034C10.319 83.599 1 91.122 1 101.194z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag1);
export default __webpack_public_path__ + "static/media/icon_flag_1.d33b8ba315398d84a4b3c7ca40da5bd5.svg";
export { ForwardRef as ReactComponent };